import React, { useMemo } from 'react'

import { ItemCardVariant } from './ItemCard'
import ItineraryItemCard from './ItineraryItemCard'

import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'
import { ThingToDoItem } from 'tripPlanner/types/tripItem'
import {
  formatDaysAndTime,
  formatShortDateAndTimeRange,
} from 'tripPlanner/utils'
import { getDisplayableCustomThingToDoName } from 'tripPlanner/utils/itemConversions/common'

interface Props {
  item: ThingToDoItem
  onClickTripName?: () => void
  variant: ItemCardVariant
}

export default function ThingTodoItemCard({
  item,
  onClickTripName,
  variant,
}: Props) {
  const {
    startDay,
    endDay,
    startDate,
    startTime,
    endDate,
    endTime,
    confirmationCode,
  } = item

  const timeFormat = useRegionTimeFormat()

  const displayDates = useMemo(
    () =>
      startDay
        ? formatDaysAndTime({
            startDay,
            endDay,
            startTime,
            endTime,
            timeFormat,
          })
        : formatShortDateAndTimeRange({
            startDate,
            startTime,
            endDate,
            endTime,
            timeFormat,
          }),
    [endDate, endDay, endTime, startDate, startDay, startTime, timeFormat],
  )

  return (
    <ItineraryItemCard
      item={item}
      name={getDisplayableCustomThingToDoName(item)}
      imgSrc={item.startPlace.photoUrl}
      placeId={'id' in item.startPlace ? item.startPlace.id : undefined}
      locationDescription={item.startPlace.region}
      descriptors={[displayDates]}
      address={item.startPlace.address}
      confirmationCode={confirmationCode}
      confirmationCodeLabel="Confirmation number"
      onClickTripName={onClickTripName}
      variant={variant}
    />
  )
}
